export const MemberShipLayoutConstants = {
	totalSteps: 6,
	SUBMIT_FORM_BUTTON_ID: "membership-form-button",
}
